import { useCallback } from "react";
import { PrintOptions, UsePrintResponse } from "./types";

export const usePrint = (): UsePrintResponse => {
  const print = useCallback(async (html: string, options?: PrintOptions) => {
    const printWindow = document.createElement("iframe");
    printWindow.width = `${document.documentElement.clientWidth}px`;
    printWindow.height = `${document.documentElement.clientHeight}px`;
    printWindow.style.position = "absolute";
    printWindow.style.top = `-${document.documentElement.clientHeight + 100}px`;
    printWindow.style.left = `-${document.documentElement.clientWidth + 100}px`;
    printWindow.id = "printWindow";
    printWindow.srcdoc = "<!DOCTYPE html>";

    printWindow.onload = () => {
      const domDoc =
        printWindow.contentDocument || printWindow.contentWindow?.document;
      if (domDoc) {
        domDoc.body.innerHTML = html;
      }
    };
    document.body.appendChild(printWindow);

    setTimeout(async () => {
      if (printWindow.contentWindow) {
        printWindow.contentWindow.focus(); // Needed for IE 11?

        const tempContentDocumentTitle =
          printWindow.contentDocument?.title ?? "";
        const tempOwnerDocumentTitle = printWindow.ownerDocument.title;

        printWindow.ownerDocument.title = "";
        printWindow.contentWindow.print();

        // restore the original title
        if (printWindow.contentDocument) {
          printWindow.contentDocument.title = tempContentDocumentTitle;
        }
        printWindow.ownerDocument.title = tempOwnerDocumentTitle;

        // make sure to remove the iframe from the dom
        const documentPrintWindow = document.getElementById("printWindow");

        if (documentPrintWindow) {
          document.body.removeChild(documentPrintWindow);
        }

        options?.afterPrint?.();
      }
    }, 500);
  }, []);

  return { print };
};
